"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EditDesignButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _i18n = require("../../../../../Framework/i18n");
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _CallToAction = _interopRequireDefault(require("../../../../Shared/Components/CallToAction"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    button: _defineProperty({
      pointerEvents: 'all'
    }, theme.breakpoints.down('xs'), {
      height: 56
    }),
    buttonXs: {
      pointerEvents: 'all',
      height: 56,
      textTransform: 'none'
    },
    initialCallWrapper: _defineProperty({
      position: 'absolute',
      right: '110%',
      minWidth: 253,
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      color: theme.palette.secondary.dark,
      '& div': {
        marginBottom: 0
      }
    }, theme.breakpoints.down('sm'), {
      right: 0,
      top: 50,
      display: 'block',
      textAlign: 'center',
      width: '100%',
      '& div': {
        marginBottom: 15
      }
    })
  };
};
var EditDesignButton = exports.EditDesignButton = (0, _withWidth["default"])({
  initialWidth: 'lg'
})((0, _styles.withStyles)(styles, {
  name: 'EditDesignButton'
})(function (_ref) {
  var openDesignArea = _ref.openDesignArea,
    classes = _ref.classes,
    buttonXS = _ref.buttonXS,
    width = _ref.width,
    showCallToAction = _ref.showCallToAction;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorRef = _useState2[0],
    setAnchorRef = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, buttonXS ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: openDesignArea,
    size: "large",
    fullWidth: true,
    variant: "text",
    className: (0, _clsx["default"])(classes.buttonXs, (0, _customClassName["default"])('open-editor-button')),
    ref: setAnchorRef
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: {
      paddingRight: 5
    }
  }, "edit"), (0, _i18n.t)('designAreaControlBox.editDesign'))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
    onClick: openDesignArea,
    size: "large",
    variant: "contained",
    className: (0, _clsx["default"])(classes.button, (0, _customClassName["default"])('open-editor-button')),
    fullWidth: true,
    ref: setAnchorRef
  }, (0, _i18n.t)('designAreaControlBox.editDesign'))), showCallToAction && /*#__PURE__*/_react["default"].createElement(_CallToAction["default"], {
    offsetDirection: (0, _withWidth.isWidthDown)('sm', width) ? 'bottom' : 'left',
    anchorRef: anchorRef,
    offset: 30,
    label: (0, _i18n.t)('initialCallToAction.selectLogoPosition'),
    className: (0, _customClassName["default"])('add-element-designer')
  }));
}));
var _default = exports["default"] = EditDesignButton;